import { useTranslations } from "next-intl";
import Link from "next/link";

export default function AlreadyLogin() {
  const t = useTranslations("Auth");
  return (
    <div className="bg-slate-50 p-8 rounded-4xl text-center border-2 border-slate-100">
      <div className="w-16 h-16 bg-main/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <div className="w-3 h-3 bg-main rounded-full animate-ping" />
      </div>
      <p className="font-bold text-slate-800 mb-6">{t("alreadyLoggedIn")}</p>
      <Link
        href="/"
        className="w-full block bg-main text-white py-4 rounded-2xl font-black hover:bg-main/90 transition-all shadow-xl shadow-main/20"
      >
        {t("goToHome")}
      </Link>
    </div>
  );
}
